import { z } from 'zod';

import { BaseWidgetSchema } from './BaseWidgetSchema';
import { ProseMirrorJSONSchema } from './ProseMirrorJSONSchema';
import { WidgetType } from '../../utils/widgetsUtils';

export const TextWidgetStaticSchema = BaseWidgetSchema(WidgetType.Text).extend({
  textType: z.string(),
  withParagraphOption: z.boolean().optional(),
  /**
   * ProseMirror JSON
   */
  fragment: ProseMirrorJSONSchema,
  placeholder: z.string(),
  style: z.record(z.unknown())
});

export type TextWidgetStaticSchemaType = z.infer<typeof TextWidgetStaticSchema>;
